import createApiServices from './createApiServices'
import {BACKEND_URL} from "../ConfigUrlApi"

const api = createApiServices({baseUrl: BACKEND_URL})

export const getCustomers = (payload, userName) => {
    return api.makeRequest({
        url: `/crm/searchCust?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const updateCustomers = (payload, userName) => {
    return api.makeRequest({
        url: `/crm/updateCust?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const updateTenantHub = (payload, userName) => {
    return api.makeRequest({
        url: `/setting/tenant/updateTenantHub?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const addCustomers = (payload) => {
    return api.makeRequest({
        url: '/crm/addCust',
        method: 'POST',
        data: payload
    })
}

export const searchCust = (payload, userName) => {
    return api.makeRequest({
        url: `/crm/searchCust?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const searchLeadByCustomer = (payload, userName) => {
    return api.makeRequest({
        url: `/crm/searchLead?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const getProcessByCustId = (payload, userName) => {
    return api.makeRequest({
        url: `/crm/getProcessByCustId?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}
